<template lang="pug">
  .color-kit-hero-v2.container
    .row
      .fixed-width-tweak-upper-max
        .side-by-side-wrap.xs-12
          .product-imagery.xs-12.lg-6
            ColorKitImageryCarouselV2

          .product-info-ctas.xs-12.lg-6
            .color-kit-info
              h1.xs-f-xlarge.max-at-tweak
                span.block.text-color-3.xs-f-small.md-f-medium.max-at-tweak {{ product.product_type_display_name }}
                span.brand-color-1.kapra-neue.upper.xs-f-xlarge.md-f-xgrande.lg-f-xxgrande.xl-f-xxxgrande.max-at-tweak {{ product.name }}

              .reviews-wrap(itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating")
                meta(itemprop="ratingValue" :content="reviewSummary.average")
                meta(itemprop="reviewCount" :content="reviewSummary.count")
                button.stars-wrap.btn-reset.xs-f-xsmall.md-f-small.max-at-tweak(role="button" @click="scrollToReviews")
                  stars.inline-block(:rating="reviewSummary.average")
                  span.review-count.underline.semi-bold {{ reviewSummary.count }} Reviews

              p.short-desc.brand-color-1.semi-bold.xs-f-small.max-at-tweak {{ product.short_description }}

              template(v-if="!onPagePurchaseBoxExperiment")
                PdpPriceModule.xs-mb-50m(v-if="showPriceModule")
                
                .product-price(v-else)
                  p.xs-f-small.max-at-tweak
                    span.text-color-3.xs-f-xsmall.max-at-tweak From&nbsp;
                    span.brand-color-1.semi-bold {{ $currency(productPrice) }}

            FindYourShadeCta(:product="product")
            
            .value-prop-icons
              ValueProps(:product="product")

            ChangeColorCTAs.mb-100m(v-if="subscription.id")
            
            PdpCtasV2(:class="{'mt-200m': !subscription.id}" cta-source="ColorKit")

            ColorKitHeroAccordion

</template>

<script>
  import { mapState } from 'vuex';
  import ValueProps from './ValueProps';
  import FindYourShadeCta from './FindYourShadeCta';
  import ColorKitHeroAccordion from './ColorKitHeroAccordion';
  import ChangeColorCTAs from './ChangeColorCTAsV2.vue';
  import PdpCtasV2 from './PdpCtasV2';
  import OnPagePurchaseBox from '@components/PDP/OnPagePurchaseBox';

  import ColorKitImageryCarouselV2 from '@components/PDP/ColorKitPdpV2/ColorKitHeroV2/ColorKitImageryCarouselV2';
  import PdpPriceModule from "@components/PDP/PdpPriceModule/PdpPriceModule";

  export default {
    name: "ColorKitHeroV2",

    components: {
      ValueProps,
      FindYourShadeCta,
      ColorKitHeroAccordion,
      PdpCtasV2,
      ColorKitImageryCarouselV2,
      PdpPriceModule,
      ChangeColorCTAs,
      OnPagePurchaseBox
    },

    computed: {
      ...mapState('pdp', [
        'product',
        'subscription',
        'showPriceModule',
        'addPerfectPair',
      ]),

      ...mapState('cms', ['cmsSettings']),

      reviewSummary() {
        return this.product?.reviewInfo || {};
      },

      productPrice() {
        let price = this.product.price;

        if ((this.product.renewable && !this.skipPurchasePanel) || this.purchaseType == 'subscription') {
          price = this.product.sub_price;
        }

        return price;
      },

      onPagePurchaseBoxExperiment() {
        return ((this.experiments["PDP On Page Purchase Box"] == "B") || (this.experiments["PDP On Page Purchase Box"] == "C")) && !(this.cmsSettings.showPerfectPairRoutine && this.addPerfectPair);
      },
    },

    methods: {
      scrollToReviews() {
        this.$root.scrollTo('.review-wrap');
        this.trackMREvent('ColorKitHeroV2 - Review Stars Clicked');
      },
    }
  };
</script>

<style scoped lang="stylus">
  .color-kit-hero-v2
    .product-info-ctas
      padding 1em 3%
      
      .reviews-wrap
        .stars-wrap
          .review-count
            position relative
            padding-left 1.2em
            
            &:before
              position absolute
              content ''
              top 50%
              left 0.6em
              width 4px
              height 4px
              background-color brand-color-1
              border-radius 50%
              margin-left -2px
              margin-top -2px
              
      .short-desc
        padding-top 0.25em
        padding-bottom 0.5em
        
      .product-price
        padding-bottom 0.25em
    
    @media mq-desktop-plus
      .side-by-side-wrap
        padding 0 2%

      .product-imagery
        position sticky
        top 3em
      
</style>